import { FC, PropsWithChildren, useEffect, useRef } from 'react';
import { Popover } from 'molecules/Popover';
import { CartPopupContent } from 'organisms/CartPopupContent';
import { LoginPopupContent } from 'organisms/LoginPopupContent';
import { motion } from 'modules/framer-motion';
import { TRANSITION_DURATION } from 'modules/framer-motion/constants';
import { getFadeAnimation } from 'modules/framer-motion/presets';
import { usePathname } from 'modules/next/hooks';
import { usePopoverManager } from 'modules/shop/popoverManager/hooks';
import { PopoverType } from 'modules/shop/popoverManager/types';
import { useNavElement } from '../../hooks';

const FadeAnimation: FC<PropsWithChildren> = ({ children }) => (
  <motion.div {...getFadeAnimation()}>{children}</motion.div>
);

export const HeaderPopoverBare: FC<{
  anchorEl?: HTMLElement | null;
  activePopover: PopoverType | null;
  closePopover: () => void;
}> = ({ anchorEl, activePopover, closePopover }) => {
  const pathname = usePathname();
  const isFirstTime = useRef(true);

  const isLogin = PopoverType.LOGIN === activePopover;
  const isCart = PopoverType.CART === activePopover;

  useEffect(() => {
    if (!isFirstTime.current) {
      closePopover();
    }

    isFirstTime.current = false;
  }, [pathname]);

  return anchorEl && (isLogin || isCart) ? (
    <Popover
      transitionDuration={TRANSITION_DURATION}
      onClose={closePopover}
      open={isLogin || isCart}
      anchorEl={anchorEl}
    >
      {isLogin && (
        <FadeAnimation>
          <LoginPopupContent />
        </FadeAnimation>
      )}
      {isCart && (
        <FadeAnimation>
          <CartPopupContent />
        </FadeAnimation>
      )}
    </Popover>
  ) : null;
};

export const HeaderPopover: FC = () => {
  const { activePopover, closePopover } = usePopoverManager();

  const anchorEl = useNavElement();

  return (
    <HeaderPopoverBare
      anchorEl={anchorEl}
      activePopover={activePopover}
      closePopover={closePopover}
    />
  );
};
